import React from 'react';

import TranslatedCopy from '../../intl/translated-copy';

function AccountNumberRecoveryError({ closeModalLogin }) {
  return (
    <>
      <div className='AccountNumberRecoveryError-Message'>
        <div className='AccountNumberRecoveryError-Icon'>
          <span className='Icon Icon--search-icon' />
        </div>
        <TranslatedCopy
          className='AccountNumberRecoveryError-Icon-title'
          copyID='PRO_HOME_FORGOT_MY_USER_ERROR_TITLE'
          tagName='p'
        />
        <TranslatedCopy
          className='AccountNumberRecoveryError-Icon-text'
          copyID='PRO_HOME_FORGOT_MY_USER_ERROR_DESCRIPTION'
          tagName='p'
        />
      </div>
      <button
        className='AccountNumberRecoveryError-Button'
        onClick={ closeModalLogin } >
        <TranslatedCopy copyID='PRO_HOME_FORGOT_MY_USER_ERROR_BUTTON' />
      </button>
  </>
  );
}

export default AccountNumberRecoveryError;